/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesAudioValidatorsSearchViewController(this: JS5Object, MediaAcceptProfileService: JS5Object,
                                                                uiGridConstants: JS5Object, $location: JS5Object,
                                                                NavbarUtilService: JS5Object, ModalService: JS5Object,
                                                                $routeParams: JS5Object, BreadcrumbService: JS5Object) {
    const getData = () => {
        MediaAcceptProfileService.getValidators($routeParams.id, this.showHidden).then((validators: JS5Object) => {
            this.gridOptions.data = _.filter(validators, <JS5Object>{validatorType: 'AUDIO'});
            this.validators = validators;
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const addMapBreadCrumb = () => {
        BreadcrumbService.addBreadcrumb({
            name: this.mediaAcceptProfile.name,
            location: `/system/templates/media/acceptProfiles/edit/${this.mediaAcceptProfile.id}`,
            params: {editView: 'audio'}
        });
    };

    const navigateToEditView = (audioValidator: JS5Object) => {
        addMapBreadCrumb();
        if (_.isNil(audioValidator)) {
            $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/audioValidators/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}`);
        } else {
            $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/audioValidators/edit/${_.get(audioValidator, 'id')}`);
        }
    };
    const navigateToEditViewToCreateAudioValidator = () => {
        addMapBreadCrumb();
        $location.url(`system/templates/media/acceptProfiles/edit/${$routeParams.id}/audioValidators/edit/-1`);
    };
    const toggleVisibility = (message: string) => {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Delete Audio Validator',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            const trackNumber = _.get(_.first(this.gridApi.selection.getSelectedRows()), 'trackNumber');
            _.remove(this.validators, {trackNumber: trackNumber, validatorType: 'AUDIO'});
            _.remove(this.validators, {trackNumber: trackNumber, validatorType: 'AUDIOCHANNEL'});
            this.loadingIndicator.show = true;
            MediaAcceptProfileService.updateValidators($routeParams.id, this.validators).then(() => {
                getData();
            }).finally(() => {
                this.loadingIndicator.show = false;
                this.setFormPristine();
            })
        });
    };


    const columnDefinitions = [
        {
            field: 'trackNumber',
            type: 'number',
            width: 150,
            displayName: 'Track Number',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'format',
            displayName: 'Format',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'title',
            displayName: 'Title',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'codec',
            displayName: 'Codec',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'duration',
            width: 300,
            displayName: 'Duration',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        data: [],
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        if (!_.get(row.entity, 'hidden')) {
            navigateToEditView(row.entity);
        }
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToEditViewToCreateAudioValidator
        },
        {
            label: 'Edit',
            enabled: () => this.gridApi.selection.getSelectedCount() && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: () => _.first(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: () => toggleVisibility('Are you sure that you want to delete this Audio Validator and the Corresponding Audio Channel Validators that share the same Track Number?')
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.showHidden = $location.search().showHidden;

        getData();
    };

}

angular.module('prism-ui.mediaAcceptProfiles').component('mediaAcceptProfilesAudioValidatorsSearchView', {
    templateUrl: 'system/templates/mediaAcceptProfiles/components/validators/audio/searchView/media-accept-profiles-audio-validators-search-view-template.html',
    controller: MediaAcceptProfilesAudioValidatorsSearchViewController,
    bindings: {
        setFormPristine: '&',
        mediaAcceptProfile: '<'
    }
});
